class ErrorWhileRequesting extends Error {
    constructor(error) {
        super('An error occurred while requesting', { cause: error });
    }
}
export default ErrorWhileRequesting;
